<template>
  <v-app>
    <dashboard-core-view />
  </v-app>
</template>

<script>
  import DashboardCoreView from '@/views/dashboard/components/core/View'

  export default {
    name: 'Register',

    components: {
      DashboardCoreView,
    },

  }
</script>
